import Url from 'url-parse'
import dic from '@/assets/dictionary/index'
import { LANG } from '@/libs/constants'

const { sectionMain } = dic[LANG]

export const newMessages = (sectionMain) => {
  return {
    default: [sectionMain.msg1, sectionMain.msg2],
    thankyou: [sectionMain.thankyou1],
    thankyou2: [sectionMain.thankyou2],
    thankyou3: [sectionMain.thankyou3],
    thankyou4: [sectionMain.thankyou4],
    thankyou5: [sectionMain.thankyou5],
    thankyou6: [sectionMain.thankyou6],

    ettn: [sectionMain.ettn1, sectionMain.ettn2],
    ttn: [sectionMain.ttn1, sectionMain.ttn2],
  }
}

export default {
  namespaced: true,
  dic,
  state: {
    currentLang: 'ua',
    hideUi: {
      links: [
        'ettn',
        'thankyou',
        'thankyou2',
        'thankyou3',
        'thankyou4',
        'thankyou5',
        'thankyou6',
      ],
    },

    messages: newMessages(sectionMain),
  },

  getters: {
    getMessage(state) {
      const { query } = new Url(window.location.href, true)
      const entries = Object.keys(query)

      for (const entry of entries) {
        if (entry in state.messages) {
          return {
            message: state.messages[entry],
            key: entry,
          }
        }
      }

      return {
        message: state.messages.default,
        key: 'default',
      }
    },

    isHiddenLinks(state) {
      const { query } = new Url(window.location.href, true)
      const queryKeys = Object.keys(query)

      const check = queryKeys.some((q) => {
        return state.hideUi.links.includes(q)
      })

      return check
    },
  },
}
